import { useNavigate, useParams } from 'react-router-dom'

import { TrainingsTrainingRequestStatusEnum } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { sumMinutesToHours } from 'modules/trainings/components/MyTrainings/RequestsComponent/RequestDetailComponent/useHoursAndMinutes'
import { WizardComponent } from 'modules/trainings/components/Shared/WizardComponent'
import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'
import { useCreateTrainingRequest } from 'modules/trainings/hooks/TrainingRequests/useCreateTrainingRequest'

export interface Props {
  back: string
  selfRequest?: boolean
}

const FromCatalogWizard = ({ back }: Props) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { access, company } = useCurrentSession()
  const { create } = useCreateTrainingRequest()
  const { employee } = useCurrentSession()
  const onSubmit = async (
    status?: TrainingsTrainingRequestStatusEnum,
    data?: WizardData,
    isDraft?: boolean
  ): Promise<void> => {
    if (!data) return

    const result = await create({
      ...data,
      employeeIds:
        data?.employeeIds && data.employeeIds.length > 0
          ? data?.employeeIds
          : employee?.id
          ? [employee.id]
          : [],
      duration: sumMinutesToHours(data.duration, data.minutes),
      companyId: Number(company.id),
      status: status ? status : data.status,
      authorId: access.id,
    })

    const handled = handleResult(result, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.training_requests.create.wrong'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: isDraft
          ? i18n.t('trainings.training_requests.create.success_messages.draft')
          : i18n.t('trainings.training_requests.create.success_messages.pending'),
      })
      navigate(back)
    }
  }

  return (
    <WizardComponent
      wizardConfig={{ fromCatalog: true, trainingId: Number(id), allowDraft: true }}
      actions={{ onClose: () => navigate(back), onSubmit: onSubmit }}
    />
  )
}

export default FromCatalogWizard
